(function () {
  const block = {
    $blocks: document.querySelectorAll('.events_footer'),
    init() {
      if (this.$blocks.length && window.innerWidth <= 768) {
        PubSub.publish('embla.init', {
          name: 'events-footer-carousel',
          $els: this.$blocks,
          options: {
            loop: true
          },
          plugins: []
        });
      }
    }
  };

  block.init();
})();

